<template lang="pug">
el-card(v-show="shouldShow", v-loading.body="loading")
  .clearfix(slot="header") Администратор
  el-form(label-position="top", ref="form", :model="record", :rules="rules")

    el-row
      el-col(:sm="11")
        el-form-item(prop="name", label="Име")
          el-input(v-model="record.name")
        el-form-item(prop="username", label="Потребителско име (login)")
          el-input(v-model="record.username")

        .well(v-if="true")

          el-checkbox(v-model="record.passwordChange") Промени паролата
          br
          br
          el-form-item(prop="password", label="Парола")
            el-input(type="password", v-model="record.password", auto-complete="off", :disabled="!record.passwordChange")
          el-form-item(prop="passwordConfirm", label="Повтори парола")
            el-input(type="password", v-model="record.passwordConfirm", auto-complete="off", :disabled="!record.passwordChange")
      el-col(v-if="$auth.check('admin')", :sm="11", :offset="2")
        el-checkbox(v-model="record.isSuper") Главен администратор
        br
        br
        el-form-item(label="Правомощия")
          el-checkbox-group(v-model="record.permissions")
            el-checkbox(v-for="(v, k) in consts.permissions", :label="k", name="permissions", :key="k") {{ v }}
            //- <el-checkbox label="Online activities" name="type"></el-checkbox>
            //- <el-checkbox label="Promotion activities" name="type"></el-checkbox>
            //- <el-checkbox label="Offline activities" name="type"></el-checkbox>
            //- <el-checkbox label="Simple brand exposure" name="type"></el-checkbox>

    el-row
      el-col(:sm="20")
        el-button(type="text", icon="el-icon-arrow-left", @click="$router.push(url)") Назад към списъка
      el-col(:sm="2")
        el-button(v-if="record.id", type="danger", @click="onDelete") Изтрий
      el-col(:sm="2")
        el-button(type="primary", @click="onSubmit") {{ isNew ? 'Създай' : 'Запази' }}

</template>

<script>
import formMixin from '../mixins/formMixin.js'
export default {
  name: 'UserForm',
  mixins: [formMixin],
  props: {},
  data () {
    var validatePassword = (rule, value, callback) => {
      if (this.record.passwordChange && value.length < 6) {
        callback(new Error('Паролата е задължителна (поне 6 символа)'))
      } else {
        // this.$refs.form.validateField('passwordConfirm')
        callback()
      }
    }
    var validatePasswordConfirm = (rule, value, callback) => {
      if (this.record.passwordChange && value !== this.record.password) {
        callback(new Error('Повторете паролата'));
      } else {
        callback();
      }
    }

    return {
      apiUrl: '/users',
      url: '/users',
      loading: true,
      record: {
        id: null,
        name: '',
        username: '',
        isSuper: false,
        permissions: [],
        password: '',
        passwordConfirm: '',
        passwordChange: false
      },
      rules: {
        name: {required: true, message: 'Полето е задължително'},
        username: {required: true, type: 'string', pattern: /^\w+$/, message: 'Пилето е задължително (само латински букви и цифри)'},
        isSuper: {type: 'boolean'},
        password: [{validator: validatePassword, trigger: 'blur, change'}],
        passwordConfirm: [{validator: validatePasswordConfirm, trigger: 'blur, change', message: ''}],
      }
    }
  },
  // created () {
  //   if (!this.$auth.check('admin') && this.$auth.user().id != this.$route.params.id) {
  //     this.$router.replace('/payments')
  //   }
  // }
}
</script>

<style lang="stylus" scoped>
.el-checkbox
  display block
  margin-left 0
</style>